import {FC, useEffect, useMemo} from 'react';
import {usersApi} from 'src/api';
import {AMPAutocomplete} from 'src/components/common/AMPAutocomplete';
import {FormikProps, useFormikContext} from 'formik';
import {AMPAutocompleteProps} from 'src/components/common/AMPAutocomplete/AMPAutocomplete.types';
import {getHelperText} from 'src/utils/forms';
import {useIntl} from 'react-intl';
import {CreateRfidFormFromType} from '..';
import {useBusinessId, useAppSelector} from 'src/app/hooks';
import {managerTypes} from 'src/utils/consts';

export const ManagerForRfidDropdown: FC = () => {
    const intl = useIntl();

    const {authInfo} = useAppSelector((state) => state.common);
    const businessId = useBusinessId();

    const {setFieldValue, handleBlur, touched, errors, values} =
        useFormikContext<CreateRfidFormFromType>();

    const {data: managersData, refetch: managersRefetch} = usersApi.useGetUsersQuery({
        params: {
            page: 0,
            size: 1_000,
        },
        data: {
            userTypes: managerTypes,
            businessId: businessId,
        },
    });

    const options = useMemo(() => {
        return (
            managersData?.content?.map((manager) => {
                const label =
                    (manager?.firstName + manager?.lastName)?.length > 0
                        ? `${manager?.firstName} ${manager?.lastName}`
                        : manager?.emailAddress || '';

                return {
                    id: Number(manager?.id) ?? 0,
                    label,
                };
            }) ?? []
        );
    }, [managersData?.content]);

    const handleChangeManagerValue = (
        setFieldValue: FormikProps<CreateRfidFormFromType>['setFieldValue']
    ): AMPAutocompleteProps['onChange'] => {
        return (_event, newValue) => {
            if (!newValue) {
                setFieldValue('managerId', null);
                return;
            }
            setFieldValue('managerId', newValue.id);
        };
    };

    useEffect(() => {
        managersRefetch();
    }, []);

    return (
        <AMPAutocomplete
            options={options}
            value={options.find((item) => item.id === values['managerId'])}
            label={'managerTabForRfidDialog'}
            input={'managerId'}
            showAvatar
            onChange={handleChangeManagerValue(setFieldValue)}
            onBlur={handleBlur}
            hasError={touched?.['managerId'] && Boolean(errors['managerId'])}
            helperText={getHelperText('managerId', touched, errors, intl)}
        />
    );
};